import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    forms: {}
}

/*
forms: {
  <form_name>: {
    entries: {
      <field_label>: {
        see FormField
      }
    }
    state: {
      <field_label>: {
        value:
        touched:
        valid:
        message:
        initValue:
        initLabel:
      }
    }
  }
}
*/

const formsReducer = createSlice ({
  name: 'forms',
  initialState: initialState,
  reducers: {
    // payload:
    // label, entries, initialState 
    addForm( state, action ){
      // console.log("[addForm Reducer] ", action )
      if ( !state.forms[action.payload.label] ){
        state.forms[action.payload.label] = {
          entries: action.payload.entries,
          state: action.payload.initialState,
          isValid: false        
        }
      } 
    },
    // payload:
    // label (form), field, state
    changeFormValue( state, action ){
      const theForm = state.forms[action.payload.label];
      theForm.state[action.payload.field] = action.payload.state;
      let formIsValid1 = true;
      for (let field in theForm.state) {
        formIsValid1 = (formIsValid && theForm.state[action.payload.field].valid) || 
                       !theForm.entries[action.payload.field].validation
      }
      
      const formIsValid = Object.keys(theForm.state).reduce( (akku, key) => (
        (akku && theForm.state[action.payload.field].valid) || !theForm.entries[action.payload.field].validation
      ) , true );
        
      theForm.isValid = formIsValid;
    },
    // payload:
    // label (form), field, newLabel
    changeFieldLabel( state, action ){
      const theForm = state.forms[action.payload.label];
      theForm.entries[action.payload.field]['label']=action.payload.newLabel;
      // console.log( "Reducer ", action.payload.field, action.payload.newLabel )
    },
    // payload:
    // label (form)
    resetForm( state, action ){      
      const theForm = state.forms[action.payload.label];
      Object.keys( theForm.entries ).forEach( key => {
        theForm.state[key]['value']     = theForm.state[key]['initValue']
        theForm.state[key]['label']     = theForm.state[key]['initLabel']
        theForm.state[key]['touched']   = false;
        theForm.state[key]['valid']     = !theForm.entries[key]['validation'];
        theForm.state[key]['message']   = '';
      });
    },
    // payload:
    // label (form)
    deleteForm( state, action ){
      delete state.forms[action.payload.label];
    }
  }
})

export const formActions = formsReducer.actions;

export default formsReducer.reducer;